import { URLList } from "@/data/url_list";
import { createLogger, withApiLogging } from "@/utils/logger/logger";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

export class OperationLogSource {
  private readonly logger = createLogger("OperationLogSource");

  constructor(private readonly client: FetchApiClientMethod) {}

  async fetchLogs(page: number, pageSize: number): Promise<SATResult<unknown, SATError>> {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });
    const url = `${URLList.LOG.LIST}?${params.toString()}`;
    try {
      const data = await withApiLogging(this.logger, { method: "GET", url }, async () => {
        const response = await this.client.get(url);
        return response.data;
      });
      return SATResult.success(data);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }
}
